export const selectUsers = ({ SeatedUsers_reducer }) => {
    let users = SeatedUsers_reducer.users;
    if (users) {
        let userInfo = Object.keys(users).map(e => users[e].profile);
        userInfo = userInfo.filter(e => {
            if (e.deleted !== true) {
                return true;
            } else {
                return false;
            }
        });
        return userInfo;
    } else {
        return false;
    }
};

export const selectSeats = ({ SeatedUsers_reducer }) => {
    return SeatedUsers_reducer.seats ? SeatedUsers_reducer.seats : [];
};
export const selectSeatLimit = ({ SeatedUsers_reducer }) => {
    return SeatedUsers_reducer.seatLimit;
};
